// color design tokens export
const colorTokens = (mode: string): Record<string, Record<number, string>> => ({
  ...(mode === 'dark'
    ? {
      gray: {
        100: '#e7e7e7',
        200: '#d0d0d0',
        300: '#b8b8b8',
        400: '#a1a1a1',
        500: '#898989', // Primary
        600: '#6e6e6e',
        700: '#525252',
        800: '#373737',
        900: '#1b1b1b',
      },
      primaryBg: {
        100: '#f9f9f9',
        200: '#a1a4aa',
        300: '#727680',
        400: '#434955',
        500: '#141b2b',
        600: '#101622',
        700: '#0c101a',
        800: '#080b11',
        900: '#040509',
      },
      primary: {
        100: '#e4dfed',
        200: '#c9bedb',
        300: '#ad9eca',
        400: '#927db8',
        500: '#775da6', // Primary
        600: '#5f4a85',
        700: '#473864',
        800: '#302542',
        900: '#181321',
      },
      primaryGreen: {
        100: '#e2f0f3',
        200: '#c6e2e6',
        300: '#a9d3da',
        400: '#8dc5cd',
        500: '#70b6c1', // Primary
        600: '#5a929a',
        700: '#436d74',
        800: '#2d494d',
        900: '#162427',
      },
      secondaryGreen: {
        100: '#eef9fa',
        200: '#ddf2f5',
        300: '#cdecf1',
        400: '#bce5ec',
        500: '#abdfe7', // Primary
        600: '#89b2b9',
        700: '#67868b',
        800: '#44595c',
        900: '#222d2e',
      },
      greenAccent: {
        100: '#d2d8d9',
        200: '#a4b2b3',
        300: '#778b8d',
        400: '#496567',
        500: '#1c3e41', // Primary
        600: '#163234',
        700: '#112527',
        800: '#0b191a',
        900: '#060c0d',
      },
      primaryRed: {
        100: '#FF0000',
      },
      rgbGreen: {
        100: 'rgb(24,215,108)',
        200: 'rgb(24,194,109)',
        300: 'rgb(24,182,110)',
        400: 'rgb(24,170,111)',
        500: 'rgb(24,160,112)',
        600: 'rgb(24,150,113)',
        700: 'rgb(25,138,114)',
        800: 'rgb(25,128,114)',
        900: 'rgb(26,106,115)',
      }
    }
    : {
      gray: {
        100: '#1b1b1b',
        200: '#373737',
        300: '#525252',
        400: '#6e6e6e',
        500: '#898989',
        600: '#a1a1a1',
        700: '#b8b8b8',
        800: '#d0d0d0',
        900: '#e7e7e7',
      },
      primaryBg: {
        100: '#040509',
        200: '#080b11',
        300: '#0c101a',
        400: '#101622',
        500: '#141b2b',
        600: '#434955',
        700: '#727680',
        800: '#f9f9f9',
        900: '#ffffff',
      },
      primary: {
        100: '#181321',
        200: '#302542',
        300: '#473864',
        400: '#5f4a85',
        500: '#775da6',
        600: '#927db8',
        700: '#ad9eca',
        800: '#c9bedb',
        900: '#e4dfed',
      },
      primaryGreen: {
        100: '#162427',
        200: '#2d494d',
        300: '#436d74',
        400: '#5a929a',
        500: '#70b6c1',
        600: '#8dc5cd',
        700: '#a9d3da',
        800: '#c6e2e6',
        900: '#e2f0f3',
      },
      secondaryGreen: {
        100: '#222d2e',
        200: '#44595c',
        300: '#67868b',
        400: '#89b2b9',
        500: '#abdfe7', // Primary
        600: '#bce5ec',
        700: '#cdecf1',
        800: '#ddf2f5',
        900: '#eef9fa',
      },
      greenAccent: {
        100: '#060c0d',
        200: '#0b191a',
        300: '#112527',
        400: '#163234',
        500: '#1c3e41',
        600: '#496567',
        700: '#778b8d',
        800: '#a4b2b3',
        900: '#d2d8d9',
      },
      primaryRed: {
        100: '#FF0000',
      },
      rgbGreen: {
        100: 'rgb(26,106,115)',
        200: 'rgb(25,128,114)',
        300: 'rgb(25,138,114)',
        400: 'rgb(24,150,113)',
        500: 'rgb(24,160,112)',
        600: 'rgb(24,170,111)',
        700: 'rgb(24,182,110)',
        800: 'rgb(24,194,109)',
        900: 'rgb(24,215,108)',
      },
      teaGreen: { 500: '#DCF8C6' },
      liteGreen: { 500: '#B5DFC8' },
      turquoiseBlue: { 500: '#A9D3DA' },
      black: { 500: '#000' },
      solitude: '#E5E7EB'
    }),
});

export default colorTokens;
